// Update contents object below
const contents = {
  header: 'Intel Corporation', //update with your client name
  logoTooltip: {
    href: 'https://www.intel.com/wonderful', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: 'Intel Labs is Staying One Step Ahead of Deepfakes',
    copy:
      'Intel researchers are dedicated to developing advanced AI technology to combat the threat caused by deepfake videos.'
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption:
          '“What are the watermarks of being human in real videos?” That’s the question that Intel Labs’ Senior Staff Research Scientist Dr. Ilke Demir and her team considered. Traditionally, deepfake detection programs used raw data to check for what is fake. But FakeCatcher looks for human characteristics to determine whether a video subject is real.'
      },
      {
        class: 'photo2',
        caption:
          'FakeCatcher uses Photoplethysmography (PPG), which detects vein color change in video pixels. FakeCatcher converts those PPG signals into maps and builds a deep-learning approach to classify them as fake and real. The PPG map extraction cannot be replicated, so this technology cannot be used by criminals online.'
      },
      {
        class: 'photo3',
        caption: 'Caption: TK –Photocredit: Bogdan Dinca for CORE'
      },
      {
        class: 'photo4',
        caption:
          'Bluewhite and Intel worked with Federated Wireless to deploy a 5G private wireless network alongside tractors using Bluewhite’s autonomous platform at a vineyard in California’s San Joaquin Valley. (Photo credit: Bluewhite)'
      },
      {
        class: 'photo5',
        caption:
          'An aerial view of the vineyard in California’s San Joaquin Valley where the pilot program took place. Alon Ascher hopes that with this new technology will see “the young generation coming back to the farm, as robotic farmers, with pride and joy.” (Photo credit: Bluewhite)'
      }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href: 'https://sponsorcontent.cnn.com/interactive/intel/it-starts-with-intel/', //where the cta button click drives to
    copy: '' //tooltip content
  }
};

export default contents;
